export default __webpack_public_path__ + "static/media/Tonkawa.c1a302b2.png";